import { useEffect, useLayoutEffect, useState } from "react";

export const isTouchScreen =
  "ontouchstart" in window || window.navigator.maxTouchPoints > 0;

export function blur(target: EventTarget | null): void {
  if (target && target instanceof HTMLElement) {
    requestAnimationFrame(() => target.blur());
  }
}

export function useBlockContextMenu(): void {
  useEffect(() => {
    const onContextMenu = (e: Event) => e.preventDefault();
    window.addEventListener("contextmenu", onContextMenu);
    return () => window.removeEventListener("contextmenu", onContextMenu);
  }, []);
}

export function useOrientation(): boolean {
  const checkHorizontal = () => window.innerWidth - 100 > window.innerHeight;
  const [isHorizontal, setIsHorizontal] = useState(checkHorizontal);
  useLayoutEffect(() => {
    const onResize = () => setIsHorizontal(checkHorizontal);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isHorizontal;
}

export function useGridColCount(): number {
  const calcCols = () => Math.ceil(window.innerWidth / 200);
  const [colCount, setColCount] = useState(calcCols());
  useLayoutEffect(() => {
    const onResize = () => setColCount(calcCols());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return colCount;
}
